import React from 'react'
import "./Footer.css"
import f_lgo from "../Assets/f_logo.png"
import { CiTwitter } from "react-icons/ci";
import { FaFacebook, FaLinkedinIn, FaTelegramPlane, FaYoutube } from "react-icons/fa";
import { FaMedium } from "react-icons/fa6";


export default function Footer() {
  return (
    <div className='main_footer '>
    <div className="footer_overlay"></div>

    <div className="bg_bla">
    <div className="container ">
        <div className="row align-items-center z-3 position-relative">
            <div className="col-md-6 z_upper">
                <div className="sooter_content text-center text-md-start">
                    <img src={f_lgo} className='rounded' style={{width:"180px"}} alt="" />
                    <p className="footer_para nor_font text-center mt-3 text-md-start">$RBT.network is an innovative meme coin concept designed to revolutionize the gaming and crypto communities. Our vision includes creating a forum chat where gamers, crypto enthusiasts, and casual users can freely engage in discussions, supporting freedom of speech. Additionally, our project aims to be the first gaming crypto wagering platform, allowing you to earn money, enjoy your favorite games, and compete with other players!

</p>
                </div>
            </div>
            <div className="col-md-6 z_upper">
            <div className='d-flex gap-2 gap-md-3 align-items-center justify-content-center'> 

                <a href="#ABOUT" className='robo_font footer_links'  style={{color:"#E647BF"}}>ABOUT</a>
                <a href="#WHITEPAPER" className='robo_font footer_links'  >WHITEPAPER</a>
                <a href="#Tokenomics" className='robo_font footer_links'  >Tokenomics</a>
                <a href="#Roadmap" className='robo_font footer_links'  >Roadmap</a>
                <a href="#Faq" className='robo_font footer_links'  >Faq</a>
            </div>
<div className='lower_soical_linkk'>


            <div className="lower_soical_link d-flex gap-2 justify-content-center " >
            <a href="https://x.com/RabbitsNETWORK" target="_blank"    > <span><CiTwitter /></span> </a>
            <a href="https://t.me/theRabbitsnetwork" target="_blank"    >  <span><FaTelegramPlane /></span></a>
            <a href="https://www.facebook.com/profile.php?id=61564441334055&mibextid=ZbWKwL" target="_blank"    >  <span><FaFacebook /></span></a>
           
            </div>
            <p className='ars robo_font mt-4 text-center'>2024 $RBT.network. All Rights Reserved.</p>
            </div>
            </div>
        </div>
    </div>
    </div>
   

    </div>
  )
}
